import React from 'react'
import Footer from '../components/Footer'
import Faqs from '../pages/Faqs'
import Why from '../pages/why'
import Benifits from '../pages/Benifits'
import ExperienceCards from '../pages/ExperienceCards'
import ProductCards from '../pages/ProductCards'
import Headers from '../components/Header'
import KidsToothpasteSection from '../pages/KidsToothpasteSection'
import AboutSection from '../pages/AboutSection'
import IngredientsSection from '../pages/IngredientsSection'
const index = () => {
  return (
    <div>
      {/* <Headers/> */}
      <KidsToothpasteSection/>
        <AboutSection/>
        <ProductCards/>
        
      <ExperienceCards/>
      <IngredientsSection/>
      <Benifits/>
      <Why/>
      <Faqs/>
      {/* <Footer/> */}
    </div>
  )
}

export default index